import React from 'react';
import '../../assets/privacy-policy.css';

const ChatGPTSaverPrivacy = () => {
    return (
        <div className="privacy-policy-page">
            <div className="container">
                <div className="privacy-header">
                    <h1>隱私權政策</h1>
                    <p className="last-updated">最後更新日期：2023年11月10日</p>
                </div>
                
                <div className="privacy-content">
                    <section className="policy-section">
                        <h2>1. 資訊收集</h2>
                        <p>我們可能會收集您的以下資訊：</p>
                        <ul>
                            <li><strong>個人識別資訊</strong>：如姓名、電子郵件地址、電話號碼等您主動提供的資訊。</li>
                            <li><strong>使用數據</strong>：關於您如何訪問和使用我們網站的資訊，包括您的IP地址、瀏覽器類型、訪問時間等。</li>
                            <li><strong>設備資訊</strong>：有關您用於訪問網站的設備的資訊，如設備型號、操作系統等。</li>
                        </ul>
                    </section>

                    <section className="policy-section">
                        <h2>2. 資訊使用</h2>
                        <p>我們收集的資訊可能用於：</p>
                        <ul>
                            <li>提供、維護和改進我們的服務</li>
                            <li>處理您的交易和請求</li>
                            <li>發送有關我們服務的通知</li>
                            <li>遵守法律義務</li>
                            <li>監控我們網站的使用情況</li>
                        </ul>
                    </section>

                    <section className="policy-section">
                        <h2>3. 資訊共享</h2>
                        <p>我們不會出售、交易或轉讓您的個人識別資訊給外部第三方。但在以下情況下可能會共享您的資訊：</p>
                        <ul>
                            <li>經您同意</li>
                            <li>與我們的業務合作夥伴共享以提供服務</li>
                            <li>滿足法律要求或執行我們的用戶協議</li>
                            <li>保護我們或他人的權利、財產或安全</li>
                        </ul>
                    </section>

                    <section className="policy-section">
                        <h2>4. Cookies 和跟蹤技術</h2>
                        <p>我們使用 cookies 和類似技術來跟蹤網站上的活動並保存某些資訊。Cookies 是發送到您瀏覽器的小文件，讓我們能夠識別您的瀏覽器並記住某些資訊。</p>
                        <p>您可以指示您的瀏覽器拒絕所有 cookies 或在發送 cookie 時指示。但是，如果您不接受 cookies，您可能無法使用我們網站的某些部分。</p>
                    </section>

                    <section className="policy-section">
                        <h2>5. 數據安全</h2>
                        <p>我們採取合理的措施來保護您的個人資訊不被未經授權的訪問、使用或披露。但請注意，沒有任何電子傳輸方法或存儲方法是100%安全的。</p>
                    </section>

                    <section className="policy-section">
                        <h2>6. 第三方連結</h2>
                        <p>我們的網站可能包含指向第三方網站的連結。我們對這些第三方網站的隱私政策或內容不負責任。</p>
                    </section>

                    <section className="policy-section">
                        <h2>7. 兒童隱私</h2>
                        <p>我們的服務不面向13歲以下的兒童。我們不會故意收集13歲以下兒童的個人識別資訊。</p>
                    </section>

                    <section className="policy-section">
                        <h2>8. 您的權利</h2>
                        <p>根據您所在地區的法律，您可能擁有以下權利：</p>
                        <ul>
                            <li>訪問您的個人數據</li>
                            <li>更正不準確的數據</li>
                            <li>刪除您的數據</li>
                            <li>限制或反對處理您的數據</li>
                            <li>數據可攜帶性</li>
                        </ul>
                    </section>

                    <section className="policy-section">
                        <h2>9. 隱私政策變更</h2>
                        <p>我們可能會不時更新我們的隱私政策。我們將通過在此頁面上發布新的隱私政策來通知您任何更改。我們建議您定期查看此隱私政策以了解任何變更。</p>
                    </section>

                    <section className="policy-section">
                        <h2>10. 聯繫我們</h2>
                        <p>如果您對我們的隱私政策有任何疑問，請通過以下方式聯繫我們：</p>
                        <p className="contact-info">
                            <strong>電子郵件：</strong> privacy@example.com<br />
                            <strong>地址：</strong> 台北市信義區信義路五段7號
                        </p>
                    </section>
                </div>
            </div>
        </div>
    );
};

export default ChatGPTSaverPrivacy;
